import React from "react";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";
import CompanyList from "./CompanyList";

interface Props {
  selectedCompanies: server.dto.CompanySmall[]
  onChange: (newCompanies: server.dto.CompanySmall[]) => void
  addressType: server.dto.AddressTypes;
}

const CompanyMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedCompanies}
    onRemove={props.onChange}
    getId={company => company.companyId}
    getLabel={company => <div>
      {company.name}
    </div>}
  >
    <CompanyList
      onItemSelected={(item) => props.onChange([...props.selectedCompanies, item])}
      excludeKeys={props.selectedCompanies.map(cc => cc.companyId)}
      addressType={props.addressType}
    />
  </MultiPickerSelectedItems>;
};

export default CompanyMultiPicker;